<template>
    <b-modal id="category_delete" ref="category_delete" header-class="no-border" footer-class="no-border"
             @hidden="$emit('close')"
             :title="'Delete ' + this.category.data.attributes.name + '?'">
        You can't revert back your action if you delete this data. For further query, contact Database Manager!

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('category_delete')" v-text="'Cancel'"/>

            <state-button size="sm" variant="danger" :click="deleteCategory">Delete</state-button>
        </template>
    </b-modal>
</template>

<script>
import StateButton from "../../../../../components/Common/StateButton";

export default {
    name: "CategoryDeleteModal",

    components: {
        StateButton,
    },

    props: [
        'category'
    ],

    methods: {
        hideModal(refname) {
            this.$refs[refname].hide();
        },

        deleteCategory() {
            return new Promise((success, fail) => {
                this.$store.dispatch('deleteInspectionCategory', this.category)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('deleted-category');

                            this.$notify('error filled', 'Success!', 'Deleted the category!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('category_delete');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },
    }
}
</script>

<style scoped>

</style>
